// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_2lsi9){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_25kma .flexContainer_ClRDV{display:flex;align-content:space-between}.nsAddressForm_25kma .flexContainer_ClRDV .firstCol_3rS3X{margin-right:20px}.nsAddressForm_25kma .flexContainer_ClRDV .region_2FlYq{width:70px}.optional_3wwXE{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_2lsi9",
	"nsAddressForm": "nsAddressForm_25kma",
	"flexContainer": "flexContainer_ClRDV",
	"firstCol": "firstCol_3rS3X",
	"region": "region_2FlYq",
	"optional": "optional_3wwXE"
};
module.exports = exports;
